import type { Directive } from 'vue';

import { trackEvent, type AnalyticsEventParams } from './index';

// Click-tracking directive. It fires the named GA event with
// event_innertext stamped from the element's rendered text content.

interface GaBinding {
  action?: string;
  gaParam?: AnalyticsEventParams;
}

interface GaTarget {
  __vGaHandler__?: EventListener;
}

export const vGa: Directive<HTMLElement & GaTarget, GaBinding | undefined> = {
  mounted(el, binding) {
    const value = binding.value;
    if (!value?.action) return;
    const handler: EventListener = () => {
      // innerText reflects rendered text (post-CSS), textContent is the raw
      // DOM string. Prefer innerText when the browser populates it; fall
      // back for envs (jsdom) that don't compute it.
      const text = el.innerText ?? el.textContent ?? '';
      trackEvent(value.action!, {
        event_innertext: text.trim(),
        ...value.gaParam,
      });
    };
    el.__vGaHandler__ = handler;
    el.addEventListener('click', handler);
  },
  unmounted(el) {
    const handler = el.__vGaHandler__;
    if (handler) el.removeEventListener('click', handler);
    delete el.__vGaHandler__;
  },
};
